export class SearchInput {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "cloudProvider",
            "baseName": "cloudProvider",
            "type": "Provider",
            "format": ""
        },
        {
            "name": "startDate",
            "baseName": "startDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "endDate",
            "baseName": "endDate",
            "type": "Date",
            "format": "date-time"
        },
        {
            "name": "limit",
            "baseName": "limit",
            "type": "number",
            "format": ""
        },
        {
            "name": "queryExecutionId",
            "baseName": "queryExecutionId",
            "type": "string",
            "format": ""
        },
        {
            "name": "pageToken",
            "baseName": "pageToken",
            "type": "string",
            "format": ""
        },
        {
            "name": "query",
            "baseName": "query",
            "type": "string",
            "format": ""
        },
        {
            "name": "filters",
            "baseName": "filters",
            "type": "string",
            "format": ""
        },
        {
            "name": "pathPrefix",
            "baseName": "pathPrefix",
            "type": "string",
            "format": ""
        },
        {
            "name": "snapshotId",
            "baseName": "snapshotId",
            "type": "string",
            "format": ""
        },
        {
            "name": "emailSearchFilter",
            "baseName": "emailSearchFilter",
            "type": "EmailSearchFilter",
            "format": ""
        },
        {
            "name": "directorySearchFilter",
            "baseName": "directorySearchFilter",
            "type": "DirectorySearchFilter",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SearchInput.attributeTypeMap;
    }
    constructor() {
    }
}
